// utils/block-spacing.js
export const spacingAttributes = {
    paddingTop: { type: 'string', default: '' },
    paddingBottom: { type: 'string', default: '' },
    paddingLeft: { type: 'string', default: '' },
    paddingRight: { type: 'string', default: '' },
    marginTop: { type: 'string', default: '' },
    marginBottom: { type: 'string', default: '' },
    marginLeft: { type: 'string', default: '' },
    marginRight: { type: 'string', default: '' },
    paddingTopMobile: { type: 'string', default: '' },
    paddingBottomMobile: { type: 'string', default: '' },
    paddingLeftMobile: { type: 'string', default: '' },
    paddingRightMobile: { type: 'string', default: '' },
    marginTopMobile: { type: 'string', default: '' },
    marginBottomMobile: { type: 'string', default: '' },
    marginLeftMobile: { type: 'string', default: '' },
    marginRightMobile: { type: 'string', default: '' }
};